import React, { memo } from 'react';
import DynamicFieldViewLive from '../DynamicFieldViewLive';
import { useSelector } from 'react-redux';
import { getDynamicFieldViewLiveState } from '../store/selectors/getDynamicFieldViewLive';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import dynamicFieldViewLiveReducer from '../store/reducers/dynamicFieldViewLive';
import { subSeconds, parseISO } from 'date-fns';
import usePlayTimer from '@gameday/utils/hooks/usePlayTimer';
const EMPTY_OBJECT = Object.freeze({});

initContainerData.register({
    reducers: {
        dynamicFieldViewLive: dynamicFieldViewLiveReducer
    }
});

const DynamicFieldViewLiveDataContainer = () => {
    const dfvState = useSelector(getDynamicFieldViewLiveState);
    const { pitchType, venueId, atBatIndex, playStartTime, gamePk } = dfvState;
    const { delay } = usePlayTimer() || EMPTY_OBJECT;
    let timestamp = playStartTime;

    if (delay > 0) {
        timestamp = subSeconds(parseISO(playStartTime), delay).toISOString();
    }

    return <DynamicFieldViewLive pitchType={pitchType} venueId={venueId} atBatIndex={atBatIndex} gamePk={gamePk} playStartTime={timestamp}/>;
};

export default memo(DynamicFieldViewLiveDataContainer);
